<template>
  <div class="list-container">
    <slot name="slot-dynamic-list-item"></slot>
    <div class="add-item-list" @click="addInstance" v-if="show_add"> {{ add_title }}</div>
  </div>
</template>

<script>
  import dinamycListItemComponent from './dynamicListItem'

  export default {
    components: {
      'dinamycListItemComponent': dinamycListItemComponent
    },
    props: {
      instances: null,
      add_title: String,
      base_input_name: String,
      instance_to_add: Object,
      show_add: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      addInstance: function () {
        var new_instance = {}
        Object.assign(new_instance, this.instance_to_add);
        this.instances.push(new_instance);
      },
      removeTopic: function(index){
        let instance_to_remove = this.instances[index];
        if(instance_to_remove.id==null){
          this.instances.splice(index, 1);
        }
      }
    }
  }
</script>